module.exports = __webpack_public_path__ + "static/media/wood-pattern.4c038458.png";